function getKeyboardFocusableElements(element) {
  if (!element) return [];
  const elements = element.querySelectorAll(
    'a[href], button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])'
  );
  return Array.from(elements).filter(
    (el) => !el.hasAttribute("disabled") && !el.getAttribute("aria-hidden") && !el.getAttribute("inert") && !(globalThis.getComputedStyle(el).display === "none")
  );
}

export { getKeyboardFocusableElements as g };
//# sourceMappingURL=getKeyboardFocusableElements-QqcABz0D.js.map
